// extracted by mini-css-extract-plugin
export var header = "index-module--header--3qMCB";
export var BackgroundAnimation = "index-module--BackgroundAnimation--VXpnQ";
export var hero = "index-module--hero--2bWc9";
export var leistungenTeaser = "index-module--leistungenTeaser--_0WVG";
export var leistungenPictureFirst = "index-module--leistungenPictureFirst--1Zc1W";
export var spinAround = "index-module--spinAround--16SrV";